import { AxiosResponse } from "axios";
import { axiosCoreInstance } from "../../../AxiosCoreInterceptor";
import * as ApiUrls from "./ApiUrl.DisputeResolutions";
import { DisputeResolutionsDto } from "../../../../Model/Dto/EmploymentEquity/Plan/EEDisputeResolutions";

export const DisputeResolutionsService = {
    GetDisputeResolutionsInformation: (scorecardId: string) : Promise<AxiosResponse<DisputeResolutionsDto.DisputeResolutionsDto>> => axiosCoreInstance.get(`${ApiUrls.GetDisputeResolutionsInformation}?ScorecardId=${scorecardId}`),
    SaveDisputeResolutionsInformation: (request: DisputeResolutionsDto.DisputeResolutionsDto) : Promise<AxiosResponse<DisputeResolutionsDto.DisputeResolutionsDto>> => axiosCoreInstance.post(ApiUrls.SaveDisputeResolutionsInformation, request)
}